import { RigHistoryBase } from './base/rig-history-base';

export class RigHistory extends RigHistoryBase { }